import { queryKeys } from 'utils/query';
import { addLogRecord, getLogs, GetLogsProps } from 'services/logs';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { CallBackProps } from 'models/general';
import { useCustomMutation } from './useCustomMutation';

export const useLogs = ({ patientId, startDate, endDate }: GetLogsProps) => {
  return useQuery({
    queryKey: [queryKeys.logs],
    queryFn: () => getLogs({ patientId, startDate, endDate }),
    enabled: !!patientId,
  });
};

export const useAddLog = ({ callback }: CallBackProps) => {
  const { t } = useTranslation();

  return useCustomMutation({
    fn: addLogRecord,
    onSuccess: {
      invalidateQueryKeys: [[queryKeys.patientMedicalEvents], [queryKeys.logs]],
      message: t('success_data_created', { value: t('log_label') }),
      callback,
    },
  });
};
